/**
 * Stub pages for all nav entries other than Sites. These will be filled in
 * in subsequent phases by lifting the matching step-components out of the
 * (now deleted) WorkflowPage.jsx.
 */
import ListPageToolbar from '../components/common/ListPageToolbar';
import PagePlaceholder from '../components/common/PagePlaceholder';
import DevicesPage from './DevicesPage';
export { DevicesPage };

export function makeStubPage({ title, icon, description }) {
  function StubPage() {
    return (
      <>
        <ListPageToolbar title={title} total={0} onAdd={() => {}} />
        <PagePlaceholder title={`${title} — coming soon`} icon={icon} description={description} />
      </>
    );
  }
  StubPage.displayName = `${title.replace(/\s+/g, '')}Page`;
  return StubPage;
}

export const UsersPage = makeStubPage({
  title: 'Users',
  icon: 'fa-user',
  description: 'Portal users and employees will live here.',
});

export const TalkGroupsPage = makeStubPage({
  title: 'Talk groups',
  icon: 'fa-microphone',
  description: 'Talk group management will live here.',
});

// TalkGroupsPage is now a real page — see pages/TalkGroupsPage.jsx

// Checkout is NOT a stub — it's the kiosk pairing page under pages/checkout/.
// Its sidebar icon opens /checkout in a new tab (see Sidebar.jsx), so there
// is no in-portal route for it.

export const LicensingPage = makeStubPage({
  title: 'Licensing',
  icon: 'fa-shield-alt',
  description: 'Licensing and entitlements will live here.',
});

export const NetworkPage = makeStubPage({
  title: 'Network',
  icon: 'fa-wifi',
  description: 'Wi-Fi profile management will live here.',
});

// SystemPage is now a real page — see pages/SystemPage.jsx

export const HomePage = makeStubPage({
  title: 'Home',
  icon: 'fa-home',
  description: 'Dashboard coming soon.',
});

// DSMPage is now a real page — see pages/dsm/DSMPage.jsx

